import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../index';

// Sottoscrizione live a un singolo documento Firestore. Ritorna l'oggetto
// `{ id, ...data }` oppure `null` se il documento non esiste. Loading/error
// non sono esposti: l'unico consumer (useTenant.userProfile) li ignora.
export function useDoc(path) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!path || typeof window === 'undefined' || !db) {
      setData(null);
      return;
    }
    const ref   = doc(db, path);
    const unsub = onSnapshot(
      ref,
      (snap) => setData(snap.exists() ? { id: snap.id, ...snap.data() } : null),
      () => setData(null),
    );
    return () => unsub();
  }, [path]);

  return data;
}
